<template>
  <v-app @scroll.native="handleScroll()">
    <v-toolbar v-if="successLogin && afterGetInit" app height="45" class="col-xs-12" flat fixed>
      <div class="col-xs-7 col-md-7" style="padding:0px;">
        <h3>eOrder ({{ mName }})</h3>
      </div>
      <!-- <v-spacer></v-spacer>
      <v-toolbar-title class="headline" style="min-width:30px;">
        <v-menu offset-y>
          <a slot="activator">
            <img src="./assets/loginIcon.png" alt="logo" class="navImgTitle" />
          </a>

          <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <img src="./assets/sirPos.png" />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{clientDisplayName}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider style="margin-left:15px;margin-right:15px;margin-bottom:0px;"></v-divider>
            <v-list-tile>
              <button class="btn" style="width:100%" @click="viewPurchaseHistory()">
                <v-list-tile-content>
                  <v-list-tile-title>{{$t('PurchaseHistory')}}</v-list-tile-title>
                </v-list-tile-content>
              </button>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-title>-->
    </v-toolbar>
    <v-toolbar v-if="!successLogin && afterGetInit" app height="45" class="col-xs-12" flat fixed>
      <div class="col-xs-7 col-md-7" style="padding:0px;">
        <h3>eOrder ({{ mName }})</h3>
      </div>
      <v-spacer></v-spacer>
      <v-toolbar-title v-if="needLoginAndPay" style="min-width:40px;" @click="goLogin()">
        <button class="btn">{{$t('Login')}}</button>
      </v-toolbar-title>
    </v-toolbar>

    <v-container v-if="afterGetInit==false" class="col-md-12" style="padding:0px;margin-top:47px;"></v-container>

    <v-container
      v-if="afterGetInit && loadToMain"
      class="col-md-12"
      style="padding:0px;margin-top:47px;"
    >
      <v-layout row wrap align-center>
        <v-progress-circular
          :size="100"
          :width="8"
          color="primary"
          indeterminate
          class="progress-circular"
        ></v-progress-circular>
      </v-layout>
      <div>
        <h3 v-if="qrCodeErrorMsg == ''" class="loadingMsg">{{$t('InProgressPleaseWaitAMoment')}}</h3>
        <br />
        <h3
          v-if="qrCodeErrorMsg.length>0"
          class="loadingMsg"
          style="color: red;"
        >Error : {{qrCodeErrorMsg}}</h3>
      </div>
    </v-container>

    <v-container
      v-if="afterGetInit && loadToMain == false"
      class="col-md-12"
      style="padding:0px;margin-top:47px;"
    >
      <v-layout align-center>
        <div id="saerch" class="col-md-12" style="text-align: center;">
          <div class="row">
            <!-- <div class="bCol col-xs-12 col-md-12 imgHight" style="padding: 0px;">
              <img class="bImg" src="@/assets/background.jpg" />
            </div>-->
            <div class="bCol col-xs-12 col-md-12" style="padding: 0px;">
              <img class="bImg" :src="restLogoBig" />
            </div>
            <div v-if="aboutUs != ''" style="padding: 0px;width:100%;">
              <h4
                style=" white-space: pre-wrap;font-size:20px;margin:0px;text-align: center;word-break: break-all;"
              >{{aboutUs}}</h4>
            </div>

            <!-- company info -->
            <v-card
              v-if="globalVar.mode == 'lite'"
              :color="pickerColor"
              style="text-align: left;padding:0px;margin:0px;"
              class="col-xs-12 col-md-12"
            >
              <div
                class="col-xs-12 col-md-12"
                style="width:100%;display: flex;justify-content: space-around;"
              >
                <v-btn v-if="cmpTelPh != ''" :href="cmpTelPhLink" class="cmpInfo cmpInfoBtn">
                  <strong>
                    <span class="cmpSmallTxt">Enquiry</span>
                    <br />
                    <span style="margin-top:-5px;">{{$t('Telephone')}}</span>
                  </strong>
                  <div class="cmpInfoIcon">
                    <v-icon style="font-size:26px;width:20px;">call</v-icon>
                  </div>
                </v-btn>
                <!-- <v-btn v-if="cmpTelPh == ''" class="disableCmpInfo cmpInfoBtn">
                  <strong>
                    <span class="cmpSmallTxt">Enquiry</span>
                    <br />
                    <span style="margin-top:-5px;">{{$t('Telephone')}}</span>
                  </strong>
                  <div class="cmpInfoIconDisable">
                    <v-icon style="font-size:26px;width:20px;">call</v-icon>
                  </div>
                </v-btn>-->
                <v-btn
                  v-if="cmpDirectionLocX != 0 || cmpDirectionLocY != 0"
                  class="cmpInfo cmpInfoBtn"
                  @click="opencCmpDirection()"
                >
                  <strong>
                    <span class="cmpSmallTxt">Get</span>
                    <br />
                    <span style="margin-top:-5px;">{{$t('Direction')}}</span>
                  </strong>
                  <div class="cmpInfoIcon">
                    <v-icon style="font-size:26px;width:20px;">directions</v-icon>
                  </div>
                </v-btn>
                <!-- <v-btn
                  v-if="cmpDirectionLocX == 0 && cmpDirectionLocY == 0"
                  class="disableCmpInfo cmpInfoBtn"
                >
                  <strong>
                    <span class="cmpSmallTxt">Get</span>
                    <br />
                    <span style="margin-top:-5px;">{{$t('Direction')}}</span>
                  </strong>
                  <div class="cmpInfoIconDisable">
                    <v-icon style="font-size:26px;width:20px;">directions</v-icon>
                  </div>
                </v-btn>-->
                <v-btn
                  v-if="cmpWebsite != ''"
                  class="cmpInfo cmpInfoBtn"
                  @click="opencCmpWebsite()"
                >
                  <strong>
                    <span class="cmpSmallTxt">Visit</span>
                    <br />
                    <span style="margin-top:-5px;">{{$t('Website')}}</span>
                  </strong>
                  <div class="cmpInfoIcon">
                    <v-icon style="font-size:26px;width:20px;">public</v-icon>
                  </div>
                </v-btn>
                <!-- <v-btn v-if="cmpWebsite == ''" class="disableCmpInfo cmpInfoBtn">
                  <strong>
                    <span class="cmpSmallTxt">Visit</span>
                    <br />
                    <span style="margin-top:-5px;">{{$t('Website')}}</span>
                  </strong>
                  <div class="cmpInfoIconDisable">
                    <v-icon style="font-size:26px;width:20px;">public</v-icon>
                  </div>
                </v-btn>-->
              </div>
            </v-card>

            <div
              class="col-xs-12 col-md-12"
              style="min-height:450px;background-color: rgb(242, 242, 242);"
            >
              <!-- <h2 class="searchTxt">
                  <strong>Search</strong>
              </h2>-->
              <!-- <h3 style="margin-top:10px;">
                Select Type:
                <font color="blue">{{ typeStatusTxt }}</font>
              </h3>-->

              <!-- order Type -->
              <div class="radioBtn" style="text-align: left;">
                <div
                  style="margin-top:15px;width:100%;display: flex;justify-content: space-around;"
                >
                  <!-- Sit Order -->
                  <b-button
                    v-if="CanSitOrder && (ScanOrderBtnTxt != '')"
                    :variant="outline"
                    class="typeBtnSize"
                    @click="toScanQR()"
                  >{{ScanOrderBtnTxt}}</b-button>
                  <b-button
                    v-if="CanSitOrder && (ScanOrderBtnTxt == '')"
                    :variant="outline"
                    class="typeBtnSize"
                    @click="toScanQR()"
                  >{{$t('ScanQR')}}</b-button>

                  <!-- Dine In -->
                  <b-button
                    v-if="CanDinein && (DineinBtnTxt != '')"
                    :variant="outline"
                    class="typeBtnSize"
                    @click="checkTypeStatus('CanDinein')"
                  >{{DineinBtnTxt}}</b-button>
                  <b-button
                    v-if="CanDinein && (DineinBtnTxt == '')"
                    :variant="outline"
                    class="typeBtnSize"
                    @click="checkTypeStatus('CanDinein')"
                  >{{$t('DineIn')}}</b-button>

                  <!-- Take Away -->
                  <b-button
                    v-if="CanTakeAway && (TakeAwayBtnTxt != '')"
                    :variant="outline"
                    class="typeBtnSize"
                    @click="checkTypeStatus('CanTakeAway')"
                  >{{TakeAwayBtnTxt}}</b-button>
                  <b-button
                    v-if="CanTakeAway && (TakeAwayBtnTxt == '')"
                    :variant="outline"
                    class="typeBtnSize"
                    @click="checkTypeStatus('CanTakeAway')"
                  >{{$t('TakeAway')}}</b-button>

                  <!-- Delivery -->
                  <b-button
                    v-if="CanDelivery && (DeliveryBtnTxt != '')"
                    :variant="outline"
                    class="typeBtnSize"
                    @click="checkTypeStatus('CanDelivery')"
                  >{{DeliveryBtnTxt}}</b-button>
                  <b-button
                    v-if="CanDelivery && (DeliveryBtnTxt == '')"
                    :variant="outline"
                    class="typeBtnSize"
                    @click="checkTypeStatus('CanDelivery')"
                  >{{$t('Delivery')}}</b-button>
                </div>
              </div>
              <hr />
              <div v-if="openScanQR">
                <div>
                  <p v-if="errorMessage.length>0">Error: {{errorMessage}}</p>
                </div>
                <div>
                  <div v-if="scanned.length>0">{{$t('Value')}}: {{scanned}}</div>
                  <vue-qr-reader
                    ref="qr"
                    @code-scanned="codeArrived"
                    @error-captured="errorCaptured"
                  ></vue-qr-reader>
                </div>
              </div>
              <div v-if="openScanQR == false">
                <div v-if="sltedTypeStatus == 4">
                  <!-- <v-btn color="primary" @click="toScanQR()">{{$t('ScanQRCode')}}</v-btn> -->

                  <div>{{$t('PleaseEnterTableNumber')}}:</div>
                  <v-flex justify-center>
                    <input
                      v-model="uTableNum"
                      class="form-control tablenUMInput"
                      :label="$t('TableNumber')"
                      name="uTableNum"
                      autocomplete="nope"
                      @input="uTableNum = $event.target.value"
                    />
                  </v-flex>
                  <span v-if="errorTblNumMsg.length>0" style="color:red;">{{errorTblNumMsg}}</span>
                </div>
                <div v-if="sltedTypeStatus != 4 && foodCourtMoreSchdTypeMode != true">
                  <h3 style="margin:0px;">{{$t('PickDateTimeSection')}}:</h3>
                  <div class="radioBtn" style="text-align: left;">
                    <!-- <div class="col-xs-6 col-md-6" style="padding: 0px;">
                  <label style="font-size:18px;">
                    <input
                      type="radio"
                      name="radioBtn"
                      value="Today"
                      required
                      @click="onClickRadioBtn('Today')"
                    >Today
                  </label>
                </div>
                <div class="col-xs-6 col-md-6" style="padding: 0px;">
                  <label style="font-size:18px;">
                    <input
                      type="radio"
                      name="radioBtn"
                      value="Reservation"
                      required
                      @click="onClickRadioBtn('Reservation')"
                    >Reservation
                  </label>
                  <br>
                    </div>-->

                    <div style="min-height: 80px;">
                      <!-- <div v-if="rdBtn  === 'Today'">
                    <p style="font-size:18px;">Today Date : {{ date | moment("DD/MM/YYYY") }}</p>
                      </div>-->
                      <!-- v-if="rdBtn ==='Reservation'" -->
                      <div class="col-xs-12">
                        <!-- datepicker -->
                        <div style="width:100%;">
                          <v-container
                            style="padding:0px;padding-bottom:10px;padding-top:10px;margin:0px;width:100%;"
                          >
                            <!-- ref="dialog" /// :return-value.sync="dateFromDatePicker" -->
                            <v-menu
                              v-model="menu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :color="pickerColor"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <v-text-field
                                slot="activator"
                                v-model="dpdate"
                                :color="pickerColor"
                                :label="$t('ChooseDate')"
                                prepend-icon="event"
                                readonly
                              ></v-text-field>
                              <v-date-picker
                                v-model="dpdate"
                                :allowed-dates="allowedDates"
                                :placeholder="$t('ChooseDate')"
                                :color="pickerColor"
                                scrollable
                                @change="onChangeDate(dpdate)"
                                @input="menu = false"
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  flat
                                  :color="pickerColor"
                                  @click="menu = false"
                                >{{$t('Close')}}</v-btn>
                                <!-- <v-btn
                              flat
                              color="primary"
                              @click="$refs.dialog.save(dateFromDatePicker)"
                                >OK</v-btn>-->
                              </v-date-picker>
                            </v-menu>
                          </v-container>
                        </div>
                      </div>
                    </div>

                    <!-- <div v-if="errorMsg">
                  <template>
                    <h5
                      style="margin-top: 15px; margin-bottom: -10px; color: red;"
                    >{{ errorMsgText }}</h5>
                  </template>
                    </div>-->
                  </div>
                  <!-- <h3 style="margin:0px;">Select time section :</h3> -->
                  <div class="col-xs-12 col-md-12" style="padding:0px;">
                    <!-- select -->
                    <v-flex xs12 sm12>
                      <v-icon
                        style="font-size:25px;width:24px;float:left;margin-right:10px;margin-top:20px;"
                      >access_time</v-icon>
                      <div
                        v-if="listOfTimeSsnName.length == 0 || listOfTimeSsnName.length == undefined"
                        @click="checkIsItSelectedType()"
                      >
                        <v-select
                          v-model="selected"
                          :items="listOfTimeSsnName"
                          :label="$t('TimeSection')"
                          :color="pickerColor"
                          required
                          :no-data-text="$t('PleaseSelectTheTypeAndDate')"
                          @input="onSelectTimeSsn"
                        ></v-select>
                      </div>
                      <div v-if="listOfTimeSsnName.length>1" @click="checkIsItSelectedType()">
                        <v-select
                          v-model="selected"
                          :items="listOfTimeSsnName"
                          :label="$t('TimeSection')"
                          :color="pickerColor"
                          required
                          :no-data-text="$t('PleaseSelectTheTypeAndDate')"
                          @input="onSelectTimeSsn"
                        ></v-select>
                      </div>
                      <div v-if="listOfTimeSsnName.length==1" @click="checkIsItSelectedType()">
                        <v-select
                          v-model="selected"
                          :color="pickerColor"
                          :items="listOfTimeSsnName"
                          :label="$t('TimeSection')"
                          required
                          :no-data-text="$t('PleaseSelectTheTypeAndDate')"
                        ></v-select>
                      </div>
                    </v-flex>
                  </div>
                </div>

                <div class="row">
                  <button
                    class="btn startOrderBtn"
                    @click="onSearch(uTableNum)"
                  >{{$t('StartOrder')}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-layout>
      <!-- <p>Updated on 27/06/2019</p> -->

      <v-layout class="text-xs-center">
        <v-dialog v-model="sltRadioBtnDialog" persistent width="1000">
          <v-card>
            <v-card-title
              class="headline primary lighten-2"
              primary-title
              style="color: white;"
            >{{$t('Inform')}}</v-card-title>
            <v-card-text>
              <h3>{{$t('PleaseSelectDate')}}</h3>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="sltRadioBtnDialog = false">{{$t('Close')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout class="text-xs-center">
        <v-dialog v-model="sltSsnDialog" persistent width="1000">
          <v-card>
            <v-card-title
              class="headline primary lighten-2"
              primary-title
              style="color: white;"
            >{{$t('Inform')}}</v-card-title>
            <v-card-text>
              <h3>{{$t('PleaseSelectTimeSection')}}</h3>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="sltSsnDialog = false">{{$t('Close')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout class="text-xs-center">
        <v-dialog v-model="sltTypeDialog" persistent width="1000">
          <v-card>
            <v-card-title
              class="headline primary lighten-2"
              primary-title
              style="color: white;"
            >{{$t('Inform')}}</v-card-title>
            <v-card-text>
              <h3>{{$t('PleaseSelectType')}}</h3>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="sltTypeDialog = false">{{$t('Close')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout class="text-xs-center">
        <v-dialog v-model="invalidUserDialog" persistent width="1000">
          <v-card>
            <v-card-title
              class="headline lighten-2"
              primary-title
              style="color: white;background: red;"
            >{{$t('Warning')}} !!!</v-card-title>
            <v-card-text>
              <h3>{{$t('PleaseReloadThePage')}} !!!</h3>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="invalidUserDialog = false">{{$t('Close')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout class="text-xs-center">
        <v-dialog v-model="userLoginDialog" persistent width="1000">
          <v-card>
            <v-card-title
              class="headline lighten-2"
              style="padding-top: 10px; padding-bottom: 0px;"
            >{{$t('Login')}}</v-card-title>
            <v-card-text style="padding:10px;">
              <v-container grid-list-md style="padding-top: 0px;padding-bottom: 0px;">
                <v-layout wrap>
                  <v-flex xs12>
                    <h4 class="userProfileTxt">{{$t('TelNo')}} :</h4>
                    <input
                      v-model="loginUName"
                      class="form-control"
                      name="loginUName"
                      required
                      type="text"
                      @input="loginUName = $event.target.value"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <h4 class="userProfileTxt">{{$t('Password')}} :</h4>
                    <input
                      v-model="loginUPswd"
                      class="form-control"
                      required
                      type="password"
                      name="loginUPswd"
                      @input="loginUPswd = $event.target.value"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
              <span v-if="loginErrorWTran != ''" class="txtClrRed">{{loginErrorWTran}}</span>
              <span v-if="loginError != ''" class="txtClrRed">{{loginError}}</span>
              <br />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="default" flat @click="userLoginDialog = false">{{$t('Close')}}</v-btn>
              <v-btn color="primary" flat @click="getUserDataToLogin()">{{$t('Login')}}</v-btn>
            </v-card-actions>

            <!-- <v-container style="padding-top:0px;">
              <restCardp9 v-if="mCode == 'p9'"></restCardp9>
            </v-container>-->
          </v-card>
        </v-dialog>
      </v-layout>

      <VersionDialog v-if="versionError" :key="componentKey"></VersionDialog>
    </v-container>
  </v-app>
</template>

<script>
import $ from 'jquery'
import JS from './JsonService'
import { enumEOrder_MchOption } from './JsonKey.js'
import JsonServiceForToken from './JsonServiceForToken.js'
import VueQrReader from 'vue-qr-reader/dist/lib/vue-qr-reader.umd.js'
import VersionDialog from '../src/VersionNotMatchDialog'
// import restCardp9 from './RestCardp9'
import globalVar from './GlobalVar.js'
import Templates from './Templates'
export default {
  components: {
    VueQrReader,
    VersionDialog
    // restCardp9
  },

  // eslint-disable-next-line vue/require-prop-types
  props: ['mchdCode', 'tableNumLink', 'loginKey', 'tblNum'],
  data() {
    return {
      globalVar: globalVar,
      clientDisplayName: '',
      uTableNum: '',
      errorTblNumMsg: '',
      tokenKey: '',
      successLogin: false,
      result: '',
      error: '',
      searched: false,
      mName: '',
      mCode: '',
      typeStatusTxt: '',
      CanDinein: false,
      CanTakeAway: false,
      CanDelivery: false,
      CanSitOrder: false,
      depositeFull: '',
      depositePercent: '',
      option: '',
      sltedTypeStatus: '',
      rdBtn: 'Today',
      ListOfMchtInfo: [],
      listOfTimeSchds: [],
      listOfTimeSsn: [],
      date: new Date(),
      dpdate: new Date().toISOString().substr(0, 10),
      menu: false,
      dateFromDatePicker: '',
      selected: '',
      listOfTimeSsnName: [],
      timeSsnId: '',
      finalSltDate: '',
      searchedDataList: [],
      sltRadioBtnDialog: false,
      sltSsnDialog: false,
      sltTypeDialog: false,
      invalidUserDialog: false,
      onlyOneTimeSsnName: '',
      openScanQR: false,
      scanned: '',
      // paused: false,
      // decodedContent: null,
      errorMessage: '',
      userLoginDialog: false,
      loginUName: '',
      loginUPswd: '',
      loginError: '',
      loginErrorWTran: '',
      needLoginAndPay: false,
      outline: '',
      pickerColor: '',
      getTempName: '',
      priceRateMsg: '',
      restLogo: '',
      restLogoBig: '',
      needSearch: true,
      afterGetInit: false,
      foodCourtMode: false,
      foodCourtMoreSchdTypeMode: false,
      versionError: false,
      componentKey: 0,
      aboutUs: '',
      deliveryMsg: '',
      deliveryImgUrl: '',
      cmpTelPh: '',
      cmpTelPhLink: '',
      cmpDirectionLocX: 0,
      cmpDirectionLocY: 0,
      cmpDirection: '',
      cmpWebsite: '',
      DineinBtnTxt: '',
      TakeAwayBtnTxt: '',
      DeliveryBtnTxt: '',
      ScanOrderBtnTxt: '',
      loadToMain: false,
      qrCodeErrorMsg: ''
    }
  },
  created: function() {
    // sessionStorage.setItem('version', 1000)
    // this.$session.clear()
    // sessionStorage.clear()

    $(window).ready(function() {
      $(this).scrollTop(0)
    })
    window.addEventListener('mousemove', this.handleScroll)

    // const valueQty = 0
    // sessionStorage.setItem('TotalCartItemQty', valueQty)
    // const value = []
    // sessionStorage.setItem('cart', value)
    sessionStorage.removeItem('TotalCartItemQty')
    sessionStorage.removeItem('cart')
    sessionStorage.removeItem('sltCatName')

    if (globalVar.mode == 'lite') {
      sessionStorage.setItem('paramMchdCode', this.mchdCode)
    }

    var fromCheckOut = sessionStorage.getItem('checkOutBackToSearch')
    if (fromCheckOut != 'true') {
      sessionStorage.setItem(
        'loginData',
        JSON.stringify({
          name: '',
          pwd: ''
        })
      )

      sessionStorage.setItem(
        'successLogin',
        JSON.stringify({
          successLogin: false,
          clientDisplayName: '',
          clientMobileNo: '',
          clientAddress: '',
          clientId: '',
          clientEmail: '',
          clientBalancePoint: 0,
          clientAddr1: '',
          clientAddr2: '',
          clientAddr3: '',
          clientCity: '',
          clientPostcode: '',
          clientState: '',
          clientCountryName: ''
        })
      )

      this.successLogin = false
    }

    sessionStorage.setItem('needBackPrevPosition', false)
    sessionStorage.setItem(
      'isSearched',
      JSON.stringify({
        search: false
      })
    )

    console.log(this.loginKey)
    if (this.loginKey == undefined || this.loginKey == '') {
      sessionStorage.setItem(
        'alreadyLogin',
        JSON.stringify({
          login: false
        })
      )
    } else {
      sessionStorage.setItem(
        'alreadyLogin',
        JSON.stringify({
          login: true
        })
      )
    }

    this.scanned == ''
    console.log(this.tblNum)
    this.getInitListConfig()
  },
  destroyed() {
    window.removeEventListener('mousemove', this.handleScroll)
    console.log('destroy')
  },
  methods: {
    getInitListConfig() {
      sessionStorage.setItem('checkOutBackToSearch', false)
      let initListPromise = new Promise(resolve => {
        if (sessionStorage.getItem('configData')) {
          resolve(sessionStorage.getItem('configData'))
        } else {
          fetch('/config.json')
            .then(res => res.json())
            .then(json => {
              var configData = JSON.stringify(json)
              //console.log('getJsonData.json : ' + configData)
              sessionStorage.setItem('configData', configData)
              console.log(configData)
              resolve(configData)
            })
        }
      })

      initListPromise.then(Msg => {
        console.log(Msg)
        if (JSON.parse(Msg).baseURLApi) {
          var domainName
          if (globalVar.mode == 'normal') {
            domainName = window.location.hostname
            //console.log('domainName:', domainName)

            // //For Testing
            if (globalVar.state == 'test') {
              if (
                domainName == 'localhost' ||
                domainName == '192.168.0.150' ||
                domainName == '192.168.0.193'
              ) {
                // domainName = 'eorder.postchat.us'
                //domainName = 'senjutei.mpos.us'
                //domainName = 'beizhan.mpos.us'
                domainName = 'demo.mpos.us'
                //domainName = 'test.mpos.us'
                //domainName = 'p9.mpos.us'
                //domainName = 'dtank.mpos.us'
              }
            }
          } else if (globalVar.mode == 'lite') {
            domainName = this.mchdCode
          }

          this.versionError = false
          var version = sessionStorage.getItem('version')
          const url = 'Order/GetInitList'
          const parameter = {
            av: version,
            ko: domainName
          }
          console.log(parameter)

          JS.request(url, parameter)
            .then(response => {
              console.log(response.data)
              if (
                response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
                response.data == 'Version Not Match'
              ) {
                this.componentKey += 1
                this.versionError = true
              } else {
                this.versionError = false
                if (response.data == 'This page no longer available') {
                  this.$router.replace({
                    name: 'noLongerAvlb',
                    params: { mchdCode: domainName }
                  })
                }
                if (
                  response.data == '@#=#@@=$#43@=$#Merchant Not Found@=$#0' ||
                  response.data == 'Merchant Not Found'
                ) {
                  if (globalVar.mode == 'normal') {
                    this.$router.replace('**')
                  } else if (globalVar.mode == 'lite') {
                    this.$router.replace({ name: 'NotFound' })
                  }
                } else {
                  sessionStorage.setItem(
                    'SchdTypeBtnName',
                    JSON.stringify({
                      DineIn: response.data.ListOfMchtInfo[0].se,
                      TakeAway: response.data.ListOfMchtInfo[0].sf,
                      Delivery: response.data.ListOfMchtInfo[0].sg,
                      ScanOrder: response.data.ListOfMchtInfo[0].si
                    })
                  )
                  sessionStorage.setItem(
                    'NoItemMsg',
                    response.data.ListOfMchtInfo[0].sh
                  )

                  this.getListOfMchtInfo(response.data)
                  //check whether from table number or not
                  console.log(this.tableNumLink)
                  if (
                    this.tableNumLink != '' &&
                    this.tableNumLink != undefined
                  ) {
                    this.loadToMain = true
                    //this.scanned = window.location.href
                    this.scanned = this.tableNumLink
                    console.log(this.scanned)
                    this.linkToTable()
                  }

                  this.getTimeSchdList(response.data)
                  //check login
                  if (this.loginKey != '' && this.loginKey != undefined) {
                    this.successLogin = false
                    sessionStorage.setItem(
                      'successLogin',
                      JSON.stringify({
                        successLogin: false
                      })
                    )
                    console.log('Token from daccess : ', this.loginKey)
                    sessionStorage.setItem('LoginToken', this.loginKey)
                    this.tokenKey = this.loginKey
                    this.getUserDataByToken()
                  } else {
                    if (sessionStorage.getItem('successLogin')) {
                      const value = sessionStorage.getItem('successLogin')
                      var status = JSON.parse(value)
                      this.successLogin = status.successLogin
                      this.clientDisplayName = status.clientDisplayName
                      console.log('login status: ', this.successLogin)
                      console.log('login name status: ', this.clientDisplayName)
                    }

                    if (this.successLogin) {
                      const tokenKey = sessionStorage.getItem('LoginToken')
                      if (this.tokenKey != '') {
                        this.tokenKey = tokenKey
                      } else {
                        this.tokenKey = undefined
                      }

                      if (this.tokenKey != undefined) {
                        console.log(this.tokenKey)
                        this.getUserDataByToken()
                      } else {
                        const loginValue = sessionStorage.getItem('loginData')
                        var loginStatus = JSON.parse(loginValue)
                        // console.log(loginStatus)
                        // console.log(loginStatus.name)
                        this.loginUName = loginStatus.name
                        this.loginUPswd = loginStatus.pwd
                        this.Login()
                      }
                    } else {
                      this.successLogin = false
                      sessionStorage.setItem(
                        'successLogin',
                        JSON.stringify({
                          successLogin: false
                        })
                      )
                      console.log('Token from daccess : ', this.loginKey)
                      sessionStorage.setItem('LoginToken', this.loginKey)
                      this.tokenKey = this.loginKey
                      this.getUserDataByToken()
                    }
                  }
                }
              }
            })
            .catch(error => {
              console.log(error)
              this.versionError = false
            })
        }
      })
    },
    handleScroll() {
      $('.typeBtnSize').on('click', function() {
        $('.typeBtnSize').removeClass('selectedType')
        $(this).addClass('selectedType')
      })

      // var header = document.getElementById('myDIV')
      // var btns = header.getElementsByClassName('typeBtnSize')
      // for (var i = 0; i < btns.length; i++) {
      //   btns[i].addEventListener('click', function() {
      //     var current = document.getElementsByClassName('selectedType')
      //     if (current.length > 0) {
      //       current[0].className = current[0].className.replace(
      //         ' selectedType',
      //         ''
      //       )
      //     }
      //     this.className += ' selectedType'
      //   })
      // }
      $(window).scroll(function() {
        var height = $(window).scrollTop()
        // var width = $(window).width()
        // console.log(height)
        // console.log(width)
        // if (height > 500) {
        //   $('.toolbar').addClass('white')
        // } else {
        //   $('.toolbar').removeClass('white')
        // }
        if (height >= 0) {
          $('.typeBtnSize').on('click', function() {
            $('.typeBtnSize').removeClass('selectedType')
            $(this).addClass('selectedType')
          })
        }
      })
    },
    checkIsItSelectedType() {
      if (this.typeStatusTxt != '' && this.typeStatusTxt != undefined) {
        this.sltTypeDialog = false
      } else {
        this.sltTypeDialog = true
      }
    },
    getUserDataByToken() {
      console.log(this.tokenKey)
      if (this.validURL(this.tokenKey)) {
        if (this.tokenKey != undefined) {
          let url = 'OfficialAccount/GetOADecrypt'
          let para = {
            token: this.tokenKey
          }
          JsonServiceForToken.request(url, para)
            .then(res => {
              console.log(res.data)
              if (res.data.mb != '') {
                this.loginUName = res.data.mb
                this.loginUPswd = res.data.code
                this.Login()
              } else {
                console.log(res.data)
                this.errorToken = true
              }
            })
            .catch(err => {
              console.log('err', err)
            })
        }
      }
    },
    validURL(tokenKey) {
      console.log('Token: ', tokenKey)
      if (tokenKey === null || tokenKey === '' || tokenKey === 'undefined') {
        return false
      }
      return true
    },
    getUserDataToLogin() {
      console.log(this.loginUName)
      console.log(this.loginUPswd)
      this.Login()
    },
    Login() {
      if (this.loginUName.length < 1) {
        this.loginErrorWTran = 'User Name Cannot be blank'
      } else if (this.loginUPswd.length < 1) {
        this.loginErrorWTran = 'Password Cannot be blank'
      } else {
        this.versionError = false
        var version = sessionStorage.getItem('version')
        const url = 'Order/Login'
        const para = {
          av: version,
          kp: this.mCode,
          x: this.loginUName,
          on: this.loginUPswd
        }
        console.log(para)
        JS.request(url, para)
          .then(res => {
            console.log('res: ', res.data)
            if (
              res.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
              res.data == 'Version Not Match'
            ) {
              this.componentKey += 1
              this.versionError = true
            } else {
              this.versionError = false
              if (
                res.data ==
                  '@#=#@@=$#49@=$#Invalid Username Or Password@=$#0' ||
                res.data == 'Invalid Username Or Password'
              ) {
                this.loginErrorWTran = 'Invalid Username Or Password'
              }
              if (res.data.ez) {
                if (res.data.ez != undefined || res.data.ez != '') {
                  this.loginError = ''
                  this.loginErrorWTran = ''
                  this.userLoginDialog = false
                  console.log('successLogin')
                  this.successLogin = true

                  sessionStorage.setItem(
                    'loginData',
                    JSON.stringify({
                      name: this.loginUName,
                      pwd: this.loginUPswd
                    })
                  )

                  sessionStorage.setItem(
                    'successLogin',
                    JSON.stringify({
                      successLogin: true,
                      clientDisplayName: res.data.ez,
                      clientMobileNo: res.data.az,
                      clientAddress: res.data.en,
                      clientId: res.data.m,
                      clientEmail: res.data.ly,
                      clientBalancePoint: res.data.re,
                      clientAddr1: res.data.rf,
                      clientAddr2: res.data.rg,
                      clientAddr3: res.data.rh,
                      clientCity: res.data.ri,
                      clientPostcode: res.data.rj,
                      clientState: res.data.rk,
                      clientCountryName: res.data.hm
                    })
                  )
                  this.clientDisplayName = res.data.ez
                } else {
                  this.loginError = res.data
                  this.successLogin = false
                  console.log('!successLogin')
                }
              } else {
                this.loginError = res.data
                this.successLogin = false
                console.log('!successLogin')
              }
            }
          })
          .catch(err => {
            this.loginError = err
            this.successLogin = false
            this.versionError = false
            console.log('!successLogin')
            console.log('err', err)
          })
      }
    },
    getListOfMchtInfo(data) {
      this.ListOfMchtInfo = []
      const ListOfMchtInfo = data.ListOfMchtInfo
      for (let i = 0; i < ListOfMchtInfo.length; i++) {
        this.ListOfMchtInfo.push(ListOfMchtInfo[i])
        this.mName = this.ListOfMchtInfo[i].ez
        this.mCode = this.ListOfMchtInfo[i].kp
        this.CanDinein = this.ListOfMchtInfo[i].mo
        this.CanTakeAway = this.ListOfMchtInfo[i].mp
        this.CanDelivery = this.ListOfMchtInfo[i].mq
        this.CanSitOrder = this.ListOfMchtInfo[i].ok

        let btnName = JSON.parse(sessionStorage.getItem('SchdTypeBtnName'))
        if (this.CanDinein == true) {
          this.DineinBtnTxt = btnName.DineIn
        }
        if (this.CanTakeAway == true) {
          this.TakeAwayBtnTxt = btnName.TakeAway
        }
        if (this.CanDelivery == true) {
          this.DeliveryBtnTxt = btnName.Delivery
        }
        if (this.CanSitOrder == true) {
          this.ScanOrderBtnTxt = btnName.ScanOrder
        }

        this.depositeFull = this.ListOfMchtInfo[i].ms
        this.depositePercent = this.ListOfMchtInfo[i].mt
        this.option = this.ListOfMchtInfo[i].ol
        this.getTempName = this.ListOfMchtInfo[i].kr
        this.priceRateMsg = this.ListOfMchtInfo[i].ov
        this.restLogo = this.ListOfMchtInfo[i].mv
        if (
          this.ListOfMchtInfo[i].kq != '' &&
          this.ListOfMchtInfo[i].kq != null
        ) {
          this.restLogoBig = JS.checkImg(this.ListOfMchtInfo[i].kq)
        } else {
          this.restLogoBig = require('@/assets/background.jpg')
        }
        this.aboutUs = this.ListOfMchtInfo[i].ks
        this.deliveryMsg = this.ListOfMchtInfo[i].rl
        this.deliveryImgUrl = this.ListOfMchtInfo[i].rm
        this.cmpTelPh = this.ListOfMchtInfo[i].y
        this.cmpTelPhLink = 'tel: +6' + this.cmpTelPh
        this.cmpDirectionLocX = this.ListOfMchtInfo[i].bl
        this.cmpDirectionLocY = this.ListOfMchtInfo[i].bm

        if (
          navigator.platform.indexOf('iPhone') != -1 ||
          navigator.platform.indexOf('iPad') != -1 ||
          navigator.platform.indexOf('iPod') != -1
        ) {
          /* if we're on iOS, open in Apple Maps */
          this.cmpDirection =
            'maps://maps.google.com/maps?daddr=' +
            this.cmpDirectionLocX +
            ',' +
            this.cmpDirectionLocY +
            '&amp;ll="'
        } else {
          /* else use Google */
          this.cmpDirection =
            'https://maps.google.com/maps?daddr=' +
            this.cmpDirectionLocX +
            ',' +
            this.cmpDirectionLocY +
            '&amp;ll="'
        }

        // this.cmpDirection =
        //   'https://maps.google.com/maps?daddr=' +
        //   this.cmpDirectionLocX +
        //   ',' +
        //   this.cmpDirectionLocY +
        //   '&amp;ll="'
        this.cmpWebsite = this.ListOfMchtInfo[i].sc
        //ok == sit & order == scan QR == type 4
      }
      // console.log('Mcht Code: ', this.mCode)

      this.setTempItem()

      var orderType = [
        { Name: 'CanDinein', status: this.CanDinein },
        { Name: 'CanTakeAway', status: this.CanTakeAway },
        { Name: 'CanDelivery', status: this.CanDelivery },
        { Name: '', status: this.CanSitOrder }
      ]
      var numOfSltType = 0
      var nameOfLastSltType = 0
      for (let j = 0; j < orderType.length; j++) {
        if (orderType[j].status == true) {
          numOfSltType = numOfSltType + 1
          nameOfLastSltType = orderType[j].Name
        }
      }
      // console.log(numOfSltType)
      // console.log(nameOfLastSltType)

      if (numOfSltType == 1) {
        if (nameOfLastSltType != '') {
          this.checkTypeStatus(nameOfLastSltType)
        } else if (nameOfLastSltType == '') {
          this.toScanQR()
        }
        $('.typeBtnSize').ready(function() {
          $('.typeBtnSize').addClass('selectedType')
        })
      }

      const key = 'searchedInfo'
      const value = JSON.stringify({
        kp: this.mCode
      })
      console.log(value)
      sessionStorage.setItem(key, value)

      this.needLoginAndPay = this.needPaymentOrLogin(this.option)
      console.log(this.needLoginAndPay)

      this.foodCourtMoreSchdTypeMode = false
      this.foodCourtMode = this.foodCourtOption(this.option)
      if (this.foodCourtMode) {
        if (
          this.CanDinein == false &&
          this.CanTakeAway == false &&
          this.CanDelivery == false &&
          this.CanSitOrder == false
        ) {
          alert('All SchdType is equal to false!')
        } else {
          var numOfTrueSltType = 0
          var lastSltTypeId = 0
          let schdTypeList = [
            this.CanDinein,
            this.CanTakeAway,
            this.CanDelivery,
            this.CanSitOrder
          ]
          for (let i = 0; i < schdTypeList.length; i++) {
            if (schdTypeList[i] == true) {
              lastSltTypeId = 0
              numOfTrueSltType = numOfTrueSltType + 1
              lastSltTypeId = lastSltTypeId + i + 1
            }
          }
          console.log(numOfTrueSltType)
          console.log(lastSltTypeId)

          // if (numOfTrueSltType == 1) {
          //   this.afterGetInit = false
          //   this.needSearch = false
          //   this.toMainlist(lastSltTypeId)
          // } else if (numOfTrueSltType > 1) {
          //   this.needSearch = true
          //   this.afterGetInit = true
          //   this.foodCourtMoreSchdTypeMode = true
          // }
          this.needSearch = true
          this.afterGetInit = true
          this.foodCourtMoreSchdTypeMode = true
        }

        //Check button true/false
        // if (
        //   this.CanDinein == false &&
        //   this.CanTakeAway == false &&
        //   this.CanDelivery == false &&
        //   this.CanSitOrder == false
        // ) {
        //   this.afterGetInit = false
        //   this.needSearch = false
        //   this.toMainlist()
        // } else {
        //   this.needSearch = true
        //   this.afterGetInit = true
        // }
      } else {
        this.needSearch = true
        this.afterGetInit = true
      }
    },
    opencCmpDirection() {
      //console.log(this.cmpDirection)
      window.open(this.cmpDirection)
    },
    opencCmpWebsite() {
      window.open(this.cmpWebsite)
    },
    foodCourtOption(lLevel) {
      return (lLevel & [enumEOrder_MchOption.FoodCourtMode]) != 0
    },
    needPaymentOrLogin(lLevel) {
      console.log(lLevel)
      console.log([enumEOrder_MchOption.NeedPayment])
      console.log((lLevel & [enumEOrder_MchOption.NeedPayment]) != 0)
      console.log((lLevel & [enumEOrder_MchOption.AskLoginBeforeCheckout]) != 0)
      return (lLevel & [enumEOrder_MchOption.AskLoginBeforeCheckout]) != 0
    },
    setTempItem() {
      // this.getTempName = 'temp2' //test temp2
      if (
        this.getTempName == '' ||
        (this.getTempName != 'temp1' && this.getTempName != 'temp2')
      ) {
        this.getTempName = 'temp1'
        this.outline = 'outline-primary'
        this.pickerColor = '#007bff'
      } else if (this.getTempName == 'temp1') {
        this.outline = 'outline-primary'
        this.pickerColor = '#007bff'
      } else if (this.getTempName == 'temp2') {
        this.outline = 'outline-danger'
        this.pickerColor = '#dc3545'
      }
      sessionStorage.setItem(
        'tempName',
        JSON.stringify({
          tempName: this.getTempName,
          outline: this.outline,
          color: this.pickerColor
        })
      )

      let name = this.getTempName //'temp1'
      if (name != 'temp1' && name != 'temp2') {
        name = 'temp1'
      }
      let temp = Templates[name]
      console.log('tempName: ', name)
      console.log('temp', temp)
      if (temp !== 'underfined') {
        this.$store.dispatch('updateCSS', temp)
        console.log(this.$store.dispatch('updateCSS', temp))
        //this.render = true
      }
    },
    getTimeSsnList(data) {
      this.listOfTimeSsn = []
      this.listOfTimeSsnName = []
      const listOfTimeSsn = data.ListOfTmSsn
      for (let i = 0; i < listOfTimeSsn.length; i++) {
        this.listOfTimeSsn.push(listOfTimeSsn[i])
        if (listOfTimeSsn[i].lc == true) {
          if (
            Date.parse(new Date().toISOString().substr(0, 10)) !=
            this.finalSltDate
          ) {
            this.listOfTimeSsnName.push(listOfTimeSsn[i].lb)
          } else {
            var checkCurrentTime = new Date().toTimeString()
            if (
              Number(checkCurrentTime.substr(0, 2)) <
              Number(listOfTimeSsn[i].cs.substr(11, 2))
            ) {
              this.listOfTimeSsnName.push(listOfTimeSsn[i].lb)
            } else if (
              Number(checkCurrentTime.substr(0, 2)) ==
              Number(listOfTimeSsn[i].cs.substr(11, 2))
            ) {
              if (
                Number(checkCurrentTime.substr(3, 2)) <
                Number(listOfTimeSsn[i].cs.substr(14, 2))
              ) {
                this.listOfTimeSsnName.push(listOfTimeSsn[i].lb)
              }
            }
          }
        }
      }

      if (this.listOfTimeSsnName.length == 1) {
        this.onlyOneTimeSsnName = this.listOfTimeSsnName[0]
        // console.log(this.onlyOneTimeSsnName)
        this.selected = this.onlyOneTimeSsnName
        if (this.selected != '') {
          for (let i = 0; i < this.listOfTimeSsn.length; i++) {
            if (this.selected === this.listOfTimeSsn[i].lb) {
              // console.log('lb', this.listOfTimeSsn[i].lb)
              this.timeSsnId = this.listOfTimeSsn[i].la
              this.timeSsnTimeFrom = this.listOfTimeSsn[i].cr
              this.timeSsnTimeTo = this.listOfTimeSsn[i].cs
            }
          }
        }
      }

      if (this.sltedTypeStatus == 4) {
        var scanAndOrderSsn = this.listOfTimeSsnName[0]
        console.log(scanAndOrderSsn)
        this.selected = scanAndOrderSsn
        if (this.selected != '') {
          for (let i = 0; i < this.listOfTimeSsn.length; i++) {
            if (this.selected === this.listOfTimeSsn[i].lb) {
              // console.log('lb', this.listOfTimeSsn[i].lb)
              this.timeSsnId = this.listOfTimeSsn[i].la
              this.timeSsnTimeFrom = this.listOfTimeSsn[i].cr
              this.timeSsnTimeTo = this.listOfTimeSsn[i].cs
            }
          }
        }
      }
      // console.log('Section:', this.listOfTimeSsn)
      // console.log('Section Name:', this.listOfTimeSsnName)
    },
    // toScanQR() {
    //   this.scanned = ''
    //   this.openScanQR = false
    //   this.sltedTypeStatus = 4
    //   this.typeStatusTxt = 'Sit & Order'
    //   this.finalSltDate = Date.parse(new Date().toISOString().substr(0, 10))
    //   this.scanned = 123
    //   this.getServerTmSsnList()
    // },
    toScanQR() {
      this.scanned = ''
      // this.$router.replace('/scan')
      this.openScanQR = true
      //this.verifyQR()
    },
    codeArrived(code) {
      console.log(code)
      if (code != '') {
        this.scanned = code //public
        // this.scanned = 'http://localhost:8080/so/localtest' //test
        this.loadToMain = true
        window.open(this.scanned, '_self')
        //this.linkToTable()
      }
    },
    errorCaptured(error) {
      switch (error.name) {
        case 'NotAllowedError':
          this.errorMessage = 'Camera permission denied.'
          break
        case 'NotFoundError':
          this.errorMessage = 'There is no connected camera.'
          break
        case 'NotSupportedError':
          this.errorMessage =
            'Seems like this page is served in non-secure context.'
          break
        case 'NotReadableError':
          this.errorMessage =
            "Couldn't access your camera. Is it already in use?"
          break
        case 'OverconstrainedError':
          this.errorMessage = "Constraints don't match any installed camera."
          break
        default:
          this.errorMessage = 'UNKNOWN ERROR: ' + error.message
      }
      console.error(this.errorMessage)
    },
    linkToTable() {
      this.versionError = false
      var version = sessionStorage.getItem('version')
      var cDate = new Date()
      var tz = cDate.getTimezoneOffset() * 60000
      let currentTime = cDate.getTime() - tz
      //console.log(currentTime)
      const url = 'Order/VerifyTableQRCode'
      const parameter = {
        av: version,
        kp: this.mCode,
        co: this.scanned,
        ld: currentTime
      }
      console.log(parameter)

      JS.request(url, parameter)
        .then(response => {
          console.log('VerifyTableQRCode: ', response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.componentKey += 1
            this.versionError = true
          } else {
            this.versionError = false

            //console.log(JS.IsJsonString(response.data))
            if (JS.IsJsonString(response.data)) {
              this.sltedTypeStatus = 4
              this.typeStatusTxt = 'Dine In, Scan, Order'
              this.finalSltDate = Date.parse(
                new Date().toISOString().substr(0, 10)
              )
              this.timeSsnId = response.data.la
              this.uTableNum = response.data.lz
              // console.log('kp : ', this.mCode)
              // console.log('le : ', this.finalSltDate)
              // console.log('gm : ', this.sltedTypeStatus)
              this.toMainlist(4)
              this.loadToMain = false
            } else {
              this.qrCodeErrorMsg = response.data
            }
          }
        })
        .catch(error => {
          console.log(error)
          this.versionError = false
        })
    },
    getTimeSchdList(data) {
      this.listOfTimeSchds = []
      const listOfTimeSchd = data.ListOfTmSchd
      for (let i = 0; i < listOfTimeSchd.length; i++) {
        var tmpdate = new Date(listOfTimeSchd[i].ld).toISOString().substr(0, 10)
        // console.log(listOfTimeSchd[i].ld)
        this.listOfTimeSchds.push(tmpdate)
      }
      // console.log('Date :', this.listOfTimeSchds)
    },
    allowedDates(val) {
      // console.log(val)
      for (let i = 0; i < this.listOfTimeSchds.length; i++) {
        if (String(val) === this.listOfTimeSchds[i]) {
          if (
            Date.parse(this.listOfTimeSchds[i]) <
            Date.parse(new Date().toISOString().substr(0, 10))
          ) {
            return false
          }
          return true
        }
      }
    },
    checkTypeStatus(value) {
      this.openScanQR = false
      console.log(value)
      if (value == 'CanDinein') {
        this.sltedTypeStatus = 1
        this.typeStatusTxt = 'Dine In'
        this.getSSnList()
      } else if (value == 'CanTakeAway') {
        this.sltedTypeStatus = 2
        this.typeStatusTxt = 'Take Away'
        this.getSSnList()
      } else if (value == 'CanDelivery') {
        this.sltedTypeStatus = 3
        this.typeStatusTxt = 'Delivery'
        this.getSSnList()
      } else {
        this.sltedTypeStatus = ''
      }
      console.log(this.sltedTypeStatus)
    },
    // onClickRadioBtn(value) {
    //   this.rdBtn = value
    //   this.getSSnList()
    // },
    onChangeDate(value) {
      this.rdBtn = 'Reservation'
      if (value != this.finalSltDate) {
        this.selected = ''
        this.getSSnList()
      }
    },
    getSSnList() {
      this.sltRadioBtnDialog = false
      this.sltTypeDialog = false
      this.invalidUserDialog = false

      console.log('test dateFromDatePicker: ', this.dateFromDatePicker)

      // console.log(this.listOfTimeSsn)
      // console.log(this.timeSsnId)
      console.log(this.rdBtn)
      // console.log(this.selected)
      console.log('datepicker date', this.dpdate)

      if (this.mCode != '') {
        if (this.rdBtn == '') {
          // this.sltRadioBtnDialog = true
        } else {
          if (this.sltedTypeStatus != '') {
            if (this.rdBtn === 'Today') {
              this.finalSltDate = Date.parse(
                new Date().toISOString().substr(0, 10)
              )
              console.log('kp : ', this.mCode)
              console.log('le : ', this.finalSltDate)
              console.log('gm : ', this.sltedTypeStatus)
              this.getServerTmSsnList()
            } else if (this.rdBtn === 'Reservation') {
              this.finalSltDate = Date.parse(this.dpdate)
              console.log('kp : ', this.mCode)
              console.log('le : ', this.finalSltDate)
              console.log('gm : ', this.sltedTypeStatus)
              this.getServerTmSsnList()
            }
          } else {
            // this.sltTypeDialog = true
          }
        }
      } else {
        //Can't find mCode
        this.invalidUserDialog = true
      }
    },
    getServerTmSsnList() {
      this.versionError = false
      var version = sessionStorage.getItem('version')
      const url = 'Order/GetTmSsnList'
      const parameter = {
        av: version,
        kp: this.mCode,
        le: this.finalSltDate,
        gm: this.sltedTypeStatus
      }
      console.log(parameter)

      JS.request(url, parameter)
        .then(response => {
          console.log('TmSsn: ', response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.componentKey += 1
            this.versionError = true
          } else {
            this.versionError = false
            this.getTimeSsnList(response.data)
          }
        })
        .catch(error => {
          console.log(error)
          this.versionError = false
        })
    },
    onSelectTimeSsn(event) {
      this.selected = event
      // console.log(this.selected)
      // console.log('length', this.listOfTimeSsn.length)

      if (this.selected != '') {
        for (let i = 0; i < this.listOfTimeSsn.length; i++) {
          if (this.selected === this.listOfTimeSsn[i].lb) {
            // console.log('lb', this.listOfTimeSsn[i].lb)
            this.timeSsnId = this.listOfTimeSsn[i].la
            this.timeSsnTimeFrom = this.listOfTimeSsn[i].cr
            this.timeSsnTimeTo = this.listOfTimeSsn[i].cs
          }
        }
      }
    },
    onSearch(uTableNum) {
      this.errorTblNumMsg = ''
      this.uTableNum = uTableNum
      this.sltRadioBtnDialog = false
      this.sltSsnDialog = false
      this.invalidUserDialog = false
      // console.log(this.listOfTimeSsn)
      // console.log(this.timeSsnId)
      // console.log(this.rdBtn)
      // console.log(this.selected)
      // console.log('datepicker date', this.dpdate)

      if (this.foodCourtMoreSchdTypeMode == true) {
        this.needSearch = false
        this.toMainlist(this.sltedTypeStatus)
      } else {
        var continueProgress = false
        if (this.sltedTypeStatus == 4) {
          if (uTableNum == '' || uTableNum == undefined) {
            continueProgress = false
            this.errorTblNumMsg = 'Table Number cannot be empty!'
          } else {
            if (!uTableNum.replace(/\s/g, '').length) {
              continueProgress = false
              this.errorTblNumMsg = 'Table Number cannot be empty!'
            } else {
              continueProgress = true
            }
          }
        } else {
          continueProgress = true
        }

        if (continueProgress) {
          if (this.sltedTypeStatus != '') {
            if (this.mCode != '') {
              if (this.rdBtn == '') {
                this.sltRadioBtnDialog = true
                window.history.pushState({})
              } else {
                if (this.selected != '') {
                  if (this.rdBtn === 'Today' && this.selected != '') {
                    this.finalSltDate = Date.parse(
                      new Date().toISOString().substr(0, 10)
                    )
                    // console.log('kp : ', this.mCode)
                    // console.log('la : ', this.timeSsnId)
                    // console.log('le : ', this.finalSltDate)
                    this.toMainlist(0)
                  } else if (
                    this.rdBtn === 'Reservation' &&
                    this.selected != ''
                  ) {
                    this.finalSltDate = Date.parse(this.dpdate)
                    // console.log('kp : ', this.mCode)
                    // console.log('la : ', this.timeSsnId)
                    // console.log('le : ', this.finalSltDate)
                    this.toMainlist(0)
                  }
                } else {
                  this.sltSsnDialog = true
                }
              }
            } else {
              //Can't find mCode
              this.invalidUserDialog = true
            }
          } else {
            this.sltTypeDialog = true
          }
        }
      }
    },
    toMainlist(SchdType) {
      if (
        this.foodCourtMoreSchdTypeMode &&
        (this.sltedTypeStatus == '' || this.typeStatusTxt == '')
      ) {
        this.sltTypeDialog = true
      } else {
        console.log(this.needSearch)
        console.log(SchdType)
        if (this.foodCourtMode) {
          this.timeSsnId = 0
          this.finalSltDate = 0
          this.timeSsnTimeFrom = ''
          this.timeSsnTimeTo = ''
          this.sltedTypeStatus = SchdType
        }

        if (SchdType == 4) {
          this.timeSsnTimeFrom = ''
          this.timeSsnTimeTo = ''
        }

        // if (this.needSearch == false && SchdType == 4) {
        //   this.timeSsnId = 0
        //   this.finalSltDate = 0
        //   this.timeSsnTimeFrom = ''
        //   this.timeSsnTimeTo = ''
        //   this.sltedTypeStatus = SchdType
        // } else if (this.needSearch == true && SchdType == 4) {
        //   this.timeSsnTimeFrom = ''
        //   this.timeSsnTimeTo = ''
        // }

        if (this.scanned == '' || this.scanned == undefined) {
          this.scanned = ''
          this.uTableNum = ''
        }

        // console.log(this.tblNum)
        if (this.tblNum != '' && this.tblNum != undefined) {
          console.log(this.tblNum)
          this.uTableNum = this.tblNum.trim()
        }

        const key = 'searchedInfo'
        const value = JSON.stringify({
          kp: this.mCode,
          la: this.timeSsnId,
          le: this.finalSltDate,
          cr: this.timeSsnTimeFrom,
          cs: this.timeSsnTimeTo,
          ms: this.depositeFull,
          mt: this.depositePercent,
          mw: this.sltedTypeStatus,
          ol: this.option,
          co: this.scanned,
          lz: this.uTableNum,
          ov: this.priceRateMsg,
          mv: this.restLogo,
          ks: this.aboutUs,
          rl: this.deliveryMsg,
          rm: this.deliveryImgUrl
        })
        console.log(value)
        sessionStorage.setItem(key, value)

        sessionStorage.setItem('needLoadSearch', this.needSearch)

        this.searched = true
        console.log('check value: ', value)
        sessionStorage.setItem(
          'isSearched',
          JSON.stringify({
            search: this.searched
          })
        )

        sessionStorage.setItem('fromSearch', true)
        if (globalVar.mode == 'normal') {
          this.$router.replace('/mainlist')
        } else if (globalVar.mode == 'lite') {
          var mchCd = sessionStorage.getItem('paramMchdCode')
          this.$router.replace({
            name: 'MainList',
            params: { mchdCode: mchCd }
          })
        }
      }
    },
    viewPurchaseHistory() {
      // sessionStorage.setItem(
      //   'isSearched',
      //   JSON.stringify({
      //     search: true
      //   })
      // )
      sessionStorage.setItem('viewPurchaseHistory', 'fromSearch')

      if (globalVar.mode == 'normal') {
        this.$router.replace('/PurchaseHistory')
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({
          name: 'PurchaseHistory',
          params: { mchdCode: mchCd }
        })
      }
    },
    goLogin() {
      this.loginUName = ''
      this.loginUPswd = ''
      this.loginError = ''
      this.loginErrorWTran = ''
      this.userLoginDialog = true
    }
  }
}
</script>

<style>
.tablenUMInput {
  border: var(--search-tablenUMInput-border) !important;
  width: 50% !important;
  margin: 0 auto;
  margin-top: 20px;
}
.tablenUMInput:focus,
.tablenUMInput:active {
  border: var(--search-tablenUMInput-border) !important;
  outline: none;
}
.startOrderBtn {
  background-color: var(--search-startOrderBtn-background_color) !important;
  color: var(--search-startOrderBtn-color) !important;
  width: 100%;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 10px;
  display: block;
  height: 50px;
  margin-top: 20px;
}

.typeBtnSize {
  /* width: 100px; */
  margin-bottom: 15px;
  width: 100%;
  height: 50px;
}
.typeBtnSize.selectedType {
  background-color: var(
    --search-typeBtnSize-selectedType-background_color
  ) !important;
  color: var(--search-typeBtnSize-selectedType-color) !important;
}
.cmpSmallTxt {
  font-size: 10px;
}
.cmpInfoBtn {
  max-width: 155px !important;
  text-decoration: none !important;
  border-radius: 5px !important;
  height: 45px !important;
  font-size: 14px !important;
  font-weight: bold !important;
  text-align: left !important;
}
.cmpInfoIcon {
  border: 1px solid;
  border-color: var(
    --search-typeBtnSize-selectedType-background_color
  ) !important;
  padding: 0px 3px 0px 3px;
  border-radius: 5px;
  margin-left: 3px;
}
/* .cmpInfoIconDisable {
  border: 1px solid;
  border-color: white !important;
  padding: 0px 3px 0px 3px;
  border-radius: 5px;
  margin-left: 3px;
} */
.cmpInfo {
  color: var(--search-startOrderBtn-background_color) !important;
  width: 32% !important;
  height: 55px !important;
}
.disableCmpInfo {
  pointer-events: none;
  background-color: grey !important;
  color: white !important;
  width: 32% !important;
  height: 55px !important;
}
.searchTxt {
  font-size: var(--search-searchTxt-font_size);
}
h3 {
  text-align: var(--search-h3-text_align);
}
.bCol {
  padding: var(--search-bCol-padding);
  height: var(--search-bCol-height);
}
.bImg {
  width: var(--search-bImg-width);
  height: var(--search-bImg-height);
  padding: var(--search-bImg-padding);
  object-fit: var(--search-bImg-object_fit);
}
.col-md-4 {
  float: var(--search-col_md_4-float);
  background-color: var(--search-col_md_4-background_color);
  border-radius: var(--search-col_md_4-border_radius);
}
label {
  font-size: var(--search-label-font_size);
}
@media (max-width: 1200px) {
  label {
    font-size: var(--search-mediaMax1200-label-font_size);
  }
}
@media (max-width: 450px) {
  h3 {
    font-size: var(--search-mediaMax450-h3-font_size);
  }
  h4 {
    font-size: var(--search-mediaMax450-h4-font_size);
  }
}
@media (max-width: 440px) {
  .cmpInfoBtn {
    max-width: 155px !important;
    text-decoration: none !important;
    border-radius: 5px !important;
    height: 45px !important;
    font-size: 12px !important;
    font-weight: bold !important;
    text-align: left !important;
  }
  .cmpSmallTxt {
    font-size: 8px;
  }
}
@media (max-width: 420px) {
  .cmpInfoBtn {
    max-width: 155px !important;
    text-decoration: none !important;
    border-radius: 5px !important;
    height: 45px !important;
    font-size: 10px !important;
    font-weight: bold !important;
    text-align: left !important;
  }
  .cmpSmallTxt {
    font-size: 8px;
  }
}
@media (max-width: 995px) {
  button {
    height: var(--search-mediaMax995-bImg-height);
  } /* .imgHight {
    height: auto;
  } */
}
/* @media (max-width: 770px) {
  .bImg {
    width: 100%;
    height: auto;

  }
} */
/* .setColHgh {
  margin-bottom: var(--search-setColHgh-margin_bottom);
}

.setColHgh2 {
  margin-bottom: var(--search-setColHgh2-margin_bottom);
} */
</style>
